import { render } from "./ModalSelectSubCategoryItem.vue?vue&type=template&id=16b29341&scoped=true"
import script from "./ModalSelectSubCategoryItem.vue?vue&type=script&lang=js"
export * from "./ModalSelectSubCategoryItem.vue?vue&type=script&lang=js"

import "./ModalSelectSubCategoryItem.vue?vue&type=style&index=0&id=16b29341&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b29341"]])

export default __exports__